export default __webpack_public_path__ + "static/media/placeholder-profile-img.0d25e0a3.svg";